/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import MiscCharges from './misc-charges';
import MiscChargesDetail from './misc-charges-detail';
import MiscChargesUpdate from './misc-charges-update';
import MiscChargesDeleteDialog from './misc-charges-delete-dialog';

const MiscChargesRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<MiscCharges />} />
    <Route path="new" element={<MiscChargesUpdate />} />
    <Route path=":id">
      <Route index element={<MiscChargesDetail />} />
      <Route path="edit" element={<MiscChargesUpdate />} />
      <Route path="delete" element={<MiscChargesDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default MiscChargesRoutes;
